export default function noop() {}



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-geo/src/noop.js
// module id = ../../../../d3-geo/src/noop.js
// module chunks = 3